import { api } from '@/shared';
import type { ApiResponse } from '@/shared/types/api';

export interface Notification {
  id: string;
  title: string;
  message: string;
  type: 'INFO' | 'WARNING' | 'ERROR' | 'SUCCESS';
  metadata?: any;
  isRead: boolean;
  createdAt: string;
}

export interface NotificationResponse {
  notifications: Notification[];
  pagination: {
    total: number;
    page: number;
    limit: number;
    totalPages: number;
  };
}

export const notificationApi = {
  getNotifications: async (
    page: number = 1,
    limit: number = 10,
  ): Promise<NotificationResponse> => {
    const response = await api.get<ApiResponse<NotificationResponse>>(
      '/notifications',
      {
        params: { page, limit },
      },
    );
    return response.data;
  },

  markAsRead: async (id: string): Promise<Notification> => {
    const response = await api.patch<ApiResponse<Notification>>(
      `/notifications/${id}/read`,
    );
    return response.data;
  },

  markAllAsRead: async (): Promise<void> => {
    await api.patch<ApiResponse<void>>('/notifications/read-all');
  },
};
